import { fetchDocumentData } from './model';
import { unformatCNPJ } from '../../helpers/mask';

export const fetchCustomerDataByDocumentController = async (
  document: string,
) => {
  const formattedDocument = unformatCNPJ(document);

  try {
    return fetchDocumentData(formattedDocument);
  } catch (err) {
    console.error(err);
  }
};
